import { AxiosPromise } from 'axios';

import { UserTypes } from '../interfaces';
import { api } from './api';

export class AppAPI {
  static getAppConfig(): AxiosPromise {
    return api.get('/config/app');
  }

  static getProductCurrency(): AxiosPromise {
    return api.get('/options/currency');
  }

  static getAppOptions(): AxiosPromise {
    return api.get('/options');
  }

  static getMenuItems(): AxiosPromise {
    return api.get('/menus');
  }

  static getUserPoints(userId: string): AxiosPromise {
    return api.get(`/user/${userId}/points`);
  }

  static patchUserConditionsAndTerms(
    userId: string | undefined,
    payload: UserTypes,
  ): AxiosPromise {
    return api.patch(`/users/${userId}.jsonld`, payload);
  }

  static getFeatureByName(name: string): AxiosPromise {
    return api.get(`/features?name=${name}`);
  }

  static getGAConfig(): AxiosPromise {
    return api.get('/google-analytics/config');
  }
}
